import styled, { CreateStyled } from '@emotion/styled';
import { Theme } from 'components/theme';

export default styled as CreateStyled<Theme>;
